import React, {Component} from 'react';
import {translate} from 'react-i18next';

class Title extends Component{
	constructor(props){
		super(props);

		this.state = {
			submenu: ""
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		var submenu = this.props.search !== "" ? this.props.search : this.props.match.path.replace('/', '');

		this.setState({submenu:submenu});
	}


	componentWillUnmount(){
		this.props.onRef(null);
	}

	componentDidUpdate(){

		if(this.state.submenu !== this.props.match.path.replace('/', '')){
			this.setState({submenu:this.props.match.path.replace('/', '')});
		}
	}

	render(){
		const {t} = this.props;
		const submenu = this.state.submenu === 'petition_register/new' ? 
							'petition_register_new' 
						: this.state.submenu.indexOf('petition_register/edit') !== -1 ?
							'petition_register/view'
						: this.state.submenu;

		return (
			<div className="route">
				<h5 className="title_page" >
					{sessionStorage.getItem('health_facilities_name')} ->
					{t('sidebar.nav.home.MAIN')} -> 
					{t('sidebar.nav.patients.MAIN')} ->
					{submenu !== '' ?
						t('sidebar.nav.patients.'+submenu)
					: null}
				</h5>
			</div>
		)
			
	}
} 

export default translate('translations') (Title);